module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/album-6f68b08b34c11280b95c473017a19ec6.svg";